import React, { useState, Fragment } from 'react'

import { useWindowResize } from '../../util/hooks'

import LoadingBar from '../shared/loadingBar'
import Header from './header'
import Submenu from './subMenu'
import Container from './container'

const Layout = props => {
    const { title, mode, parm, passUrl, layout, menu, children } = props
    const [subMenu, setSubmenu] = useState(menu[0])

    const openSubmenu = menus => setSubmenu(menus)
    const hideSubmenu = () => setSubmenu(null)

    let { height } = useWindowResize()
    height = height || 0

    return (
        <div className="flex flex-col h-screen w-screen bg-bgColor">
            <Header menus={menu || []} subMenu={subMenu} handleOpenSubmenu={openSubmenu} />
            <LoadingBar position={50} />
            <div className="flex-grow flex flex-row" style={{ height: height - 50 }}>
                <Submenu menu={subMenu} handleClose={hideSubmenu} />
                <div className="flex-grow flex flex-col relative overflow-auto md:overflow-hidden">
                    <Container
                        title={title}
                        mode={mode}
                        layout={layout}
                        parm={parm}
                        passUrl={passUrl}
                    >
                        {children}
                    </Container>
                </div>
            </div>
        </div>
    )
}

export default Layout
